<template>
    <div class="Halloween_container">
        <headerWX class="headerWX"></headerWX>
        <div class="content">
            <img class="bg" src="@/assets/imgs/Halloween/bg.png" alt="">
            <div style="height: 230px;width: 1px;"></div>
            <div class="content_item" v-if="TarotData.drawHistory"
                :class="{ flipped: TarotData.currentDrawCount == 10 }">
                <div class="tit pul" :class="{ titflipped: TarotData.currentDrawCount == 10 }">
                    <div class="pop-up">
                        <img @click="popUp(3)" src="@/assets/imgs/Halloween/rule.png" alt="">
                        <img @click="popUp(4)" src="@/assets/imgs/Halloween/jackpot.png" alt="">
                    </div>
                    <div class="title">
                        <img src="@/assets/imgs/Halloween/concealtit.png" alt=""
                            v-if="TarotData.currentDrawCount == 10">
                        <img src="@/assets/imgs/Halloween/title.png" alt="" v-else>
                    </div>
                    <div class="currency">
                        <img src="@/assets/imgs/Halloween/currency.png" alt="">
                        <div class="coin">
                            <p v-if="userInfo.wallteInfos">金龙元宝：{{ userInfo.wallteInfos[0].balance }}</p>
                            <p>魔法蜡烛：{{ TarotData.loveKeys }}</p>
                        </div>
                    </div>
                </div>
                <div class="Tarot pul">
                    <div class="card-container" @click="toggleFlip(item)"
                        v-for="(item, index) in TarotData.allCardsStatus" :key="item.position">
                        <!-- 卡片容器，用于透视效果 -->
                        <div class="card" :class="{ 'flipped': item.isFlipped }">
                            <!-- <div class="card"> -->
                            <!-- 卡片正面 -->
                            <div class="card-side front">
                                <img src="@/assets/imgs/Halloween/front.png" alt="">
                                <img v-show="flickerList[index]" class="flicker" src="@/assets/imgs/Halloween/back.png"
                                    alt="">

                            </div>

                            <!-- 卡片背面 -->
                            <div class="card-side back" ref="back">

                                <img src="@/assets/imgs/Halloween/back.png" alt="">
                                <div class="it">
                                    <el-tooltip class="item" effect="dark" :content="item.itemDesc" placement="top">
                                        <img :src="item.itemImg" alt="">
                                    </el-tooltip>

                                    <!-- <img src="http://localhost:3000/src/assets/logo.png" alt=""> -->
                                    <!-- <span>{{ item.itemName }}X{{ item.itemNum }}</span> -->
                                </div>
                                <span
                                    style="position: absolute;top: 105%;left: 0;width: 100%;text-align: center;">{{
                                        item.itemName }}X{{
                                        item.itemNum }}</span>

                            </div>
                        </div>
                    </div>
                    <div class="extractionTarot">
                        <img src="@/assets/imgs/Halloween/extractionTarot.png" alt="">
                        <img src="@/assets/imgs/Halloween/extractionTarot_Tit.png" alt="">
                    </div>
                </div>
                <div class="backTarot">

                    <div class="items" v-for="item in TarotData.hiddenShopItems" :key="item.itemId">
                        <div class="item">
                            <!-- <img  src="https://bpic.588ku.com/element_origin_min_pic/23/07/11/d32dabe266d10da8b21bd640a2e9b611.jpg!r650"> -->
                            <el-tooltip class="item" effect="dark" :content="item.itemDesc" placement="top">
                                <img :src="item.itemImg">
                            </el-tooltip>

                            <div>
                                <p>{{ item.itemName }}X{{ item.itemNum }}</p>
                                <span>需{{ item.price }}魔法蜡烛兑换 <span v-if="item.limitCount !== 0">({{ item.buyCount }}/{{
                                    item.limitCount }})</span></span>
                            </div>

                        </div>
                        <img v-if="item.limitCount == 0" src="@/assets/imgs/Halloween/component/conversion.png" alt=""
                            @click="hiddenShopBuy(item)">
                        <img v-else-if="item.buyCount !== item.limitCount"
                            src="@/assets/imgs/Halloween/component/conversion.png" alt="" @click="hiddenShopBuy(item)">
                        <img v-else style="filter: grayscale(100%);"
                            src="@/assets/imgs/Halloween/component/conversion.png" alt="">
                    </div>

                </div>
            </div>
        </div>


        <!-- 弹窗 -->
        <div class="dialog" v-if="istoolTipBox" style="width: 100%;height: 100%;position: absolute;top: 0;">
            <popUp :close="cancel" :Confirm="Confirm" :type="type" :TarotIndex="TarotIndex" :nextDrawCost="nextDrawCost"
                :TarotData="TarotData"></popUp>
            <!-- <el-button @click="istoolTipBox = false">取 消</el-button> -->
            <!-- <el-button type="primary" @click="istoolTipBox = false">确 定</el-button> -->
        </div>
    </div>
</template>

<script>
import headerWX from "@/components/Header";
import popUp from './component/index.vue'
import Cookies from 'js-cookie'

import { getActivityInfoApi, exchangeApi, drawApi, buyHiddenShopItemApi } from '@/api/Qixi'
import { getMemberInfoApi } from '@/api/public.js'
export default {
    name: 'QixiIndex',
    components: {
        headerWX,
        popUp
    },
    data() {
        return {
            icon: [10, 0],
            // 弹窗控制  fslse true
            istoolTipBox: false,
            //弹窗类型
            type: 1,
            //塔罗牌索引
            TarotIndex: null,
            //用户信息
            userInfo: {},
            //活动信息
            TarotData: {},
            //本次抽奖消费的同心结
            nextDrawCost: '',

            //兑换隐藏item
            HiddenShopItem: {},

            // 闪烁list
            flickerList: []
        }
    },
    created() {

    },
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')) : '';

        this.init()
        this.getMemberInfo()
    },
    methods: {

        // 切换卡片翻转状态
        toggleFlip(item) {
            // const backEl = this.$refs.back[item - 1];
            // console.log(this.icon[1] > 0, this.icon, '000');

            if (!item.isFlipped) {
                if (this.TarotData.loveKeys < this.TarotData.nextDrawCost) {
                    // 不足
                    this.nextDrawCost = this.TarotData.nextDrawCost
                    this.popUp(1)
                    // console.log('兑换同心结');
                } else {

                    // 抽取条件不足 
                    if (this.TarotData.currentDrawCount == 10) {

                    } else if (this.TarotData.loveKeys >= this.TarotData.nextDrawCost) {
                        //抽奖
                        this.TarotIndex = item.position
                        this.nextDrawCost = this.TarotData.nextDrawCost
                        this.popUp(2)
                        // console.log('抽奖');
                    } else {
                        // 金龙元宝不足
                        this.popUp(5)
                        // console.log('跳转充值');
                    }
                }
            }

            // console.log(item, this.$refs.back[item]);

        },
        // 弹窗
        popUp(type) {
            this.type = type
            switch (type) {
                // 翻牌提示
                case 1:
                    this.istoolTipBox = true
                    break;
                // 翻牌提示
                case 2:
                    this.istoolTipBox = true
                    break;
                // 规则说明
                case 3:
                    this.istoolTipBox = true
                    break;
                // 奖池预览
                case 4:
                    this.istoolTipBox = true
                    break;
                case 5:
                    this.istoolTipBox = true
                    break;
                case 6:
                    this.istoolTipBox = true
                    break;
                default:
                    break;
            }
        },

        // 关闭弹窗
        cancel() {
            this.istoolTipBox = false
        },
        //确定兑换
        async Confirm(item) {
            // console.log(this.icon, item, '兑换');
            switch (item.type) {
                case 1:
                    if (Number(item.conversion_number) > Number(this.userInfo.wallteInfos[0].balance)) {
                        //关闭弹窗
                        this.istoolTipBox = false
                        this.popUp(5)
                    } else {
                        await exchangeApi({
                            exchangeAmount: Number(item.conversion_number),
                            userId: Cookies.get('cwsl_userId'),
                        }).then(({ data }) => {
                            if (data.state == 200) {
                                this.$message.success(data.data.message)
                                this.getMemberInfo() // 获取用户信息
                                this.init() // 获取最近抽奖状态
                                //关闭弹窗
                                this.istoolTipBox = false
                            }else{
                                this.$message.info(data.message)
                            }
                        })

                    }

                    break;
                case 2:
                    const draw = async () => {
                        await drawApi({
                            activityName: "2025halloween_activity",
                            cardPosition: item.TarotIndex,
                            userId: Cookies.get('cwsl_userId'),
                        }).then(({ data }) => {
                            if (data.state == 200) {
                                this.$message.success(data.data.message)

                                // const backEl = this.$refs.back[item.TarotIndex - 1];
                                // backEl.classList.add('lightfade');
                                // setTimeout(() => {
                                //     // backEl.classList.remove('lightfade');
                                // }, 2000); // 和 CSS 动画时长一致


                                this.init()
                                //关闭弹窗
                                // this.istoolTipBox = false
                            }
                        })
                    }
                    this.istoolTipBox = false
                    const time = setInterval(() => {
                        // ✅ 用 $set 让 Vue 追踪变化
                        this.$set(this.flickerList, item.TarotIndex - 1, !this.flickerList[item.TarotIndex - 1]);

                    }, 300);
                    setTimeout(() => {
                        clearInterval(time)
                        draw()
                        // this.TarotData.allCardsStatus[6].isFlipped = true
                    }, 1200)



                    break
                case 3:
                    //关闭弹窗
                    this.istoolTipBox = false
                    break
                case 4:
                    //关闭弹窗
                    this.istoolTipBox = false
                    break
                case 5:
                    this.$router.push('/recharge')
                    break
                case 6:
                    await buyHiddenShopItemApi({
                        activityName: "2025halloween_activity",
                        userId: Cookies.get('cwsl_userId'),
                        buyNum: this.HiddenShopItem.itemNum,
                        itemId: this.HiddenShopItem.itemId
                    }).then(({ data }) => {
                        if (data.state == 200) {
                            this.$message.success(data.data.message)
                            this.init()
                            this.istoolTipBox = false
                        } else {
                            this.$message.info(data.message)
                            this.istoolTipBox = false
                        }
                    })
                    break
                default:
                    break;
            }

        },
        // 购买隐藏道具
        hiddenShopBuy(item) {
            if (this.TarotData.loveKeys < item.price) {
                this.nextDrawCost = this.TarotData.nextDrawCost
                this.popUp(1)
            } else {
                this.nextDrawCost = item.price
                this.HiddenShopItem = item
                this.popUp(6)

            }

        },

        //获取 user信息
        async getMemberInfo() {
            await getMemberInfoApi({
                userId: Cookies.get('cwsl_userId'),      // userId
                platForm: 'web',
            }).then((res) => {
                if (res.data.state == 200) {
                    this.userInfo = res.data.data
                    this.resetSetItem('userInfo', JSON.stringify(res.data.data))
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                this.$message.error(err.message)
            })
        },          // 获取用户信息
        // 初始化
        async init() {
            await getActivityInfoApi({
                activityName: "2025halloween_activity",
                userId: Cookies.get("cwsl_userId"), // userId
                platForm: "web",
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.TarotData = data.data
                    for (let index = 0; index < data.data.allPrizes.length; index++) {
                        this.flickerList.push(false)
                    }
                    // console.log(this.flickerList, data.data.allPrizes);

                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.Halloween_container {
    min-width: 1200px;
    position: relative;
    background-image: url(../../assets/imgs/Halloween/bg.png);
    background-repeat: no-repeat;
    background-position: center center; /* 将背景图片居中显示 */
    overflow: hidden;
// background-size: cover;


    .content {
        margin: 0 auto;
        max-width: 2000px;
        width: 100%;
        position: relative;

        .bg {
            width: 100%;
            position: absolute;
        }

        .content_item {
            width: 65%;
            height: 780px;
            // top: 230px;
            // margin-top: 230px;
            margin: auto;
            background: rgba(255, 255, 255, 0.5);
            border-radius: 20px 20px 20px 20px;
            position: relative;
            transition: transform 3s;
            transform-style: preserve-3d;

            .pul {
                width: 85%;
                margin: auto;
            }

            .tit {
                padding-top: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .pop-up {
                    img {
                        cursor: pointer;
                    }
                }

                .currency {
                    position: relative;

                    .coin {
                        width: 62%;
                        position: absolute;
                        top: 32px;
                        left: 52%;
                        transform: translateX(-50%);

                        p {
                            line-height: 20px;
                            font-weight: 700;
                            color: #fff;
                        }
                    }
                }
            }

            .Tarot {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                transition: all 0.6s linear;
                backface-visibility: hidden;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);

                /* 卡片容器，设置透视效果 */
                .card-container {
                    perspective: 1000px;
                    width: 15%;
                    // height: 175px;
                    margin: 20px 25px 0;
                    padding-bottom: 50px;
                    cursor: pointer;
                }

                .extractionTarot {
                    width: 100%;
                    text-align: center;
                    margin-top: 30px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                }

                /* 卡片样式 */
                .card {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    transition: transform 1.2s cubic-bezier(0.34, 1.56, 0.64, 1);
                    transform-style: preserve-3d;

                    /* Firefox 兼容优化 */
                    transform: translateZ(0);
                    will-change: transform;
                }

                /* 翻转状态 */
                .flipped {
                    transform: rotateY(180deg) translateZ(0);
                    transition: none !important;
                    /* Firefox hack */
                }

                /* 卡片面的共有样式 */
                .card-side {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    backface-visibility: hidden;
                    -moz-backface-visibility: hidden;
                    /* Firefox 专用 */
                    transform: translateZ(0);
                    /* 强制 GPU 渲染 */
                    will-change: transform, opacity;
                }

                /* 正面样式 */
                .front {
                    z-index: 2;
                    transition: transform 1.2s cubic-bezier(0.34, 1.56, 0.64, 1);

                    img {
                        width: 100%;
                    }

                    .flicker {
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }


                .front:hover {
                    // transition: transform 1.2s cubic-bezier(0.34, 1.56, 0.64, 1);
                    // transform: scale(1.1) rotateZ(-20deg);
                    transform: scale(1.1);
                }

                /* 背面样式 */
                .back {
                    transform: rotateY(180deg) translateZ(0);
                    position: relative;

                    >img {
                        width: 100%;
                    }

                    .it {
                        position: absolute;
                        top: 70%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        // width: 100px;
                        text-align: center;

                        >img {
                            // max-width: 100%;
                            max-width: 60px;
                            // max-height: 130px;
                        }

                        span {
                            color: #fff;
                            margin-top: 20px;
                            display: inline-block;
                        }
                    }

                    >span {
                        // overflow: hidden;
                        // /* 隐藏溢出的内容 */
                        // white-space: nowrap;
                        // /* 保持文本在一行内 */
                        // text-overflow: ellipsis;
                        /* 溢出内容显示省略号 */

                    }
                }

                .lightfade {
                    animation: lightfade 2s forwards;
                    box-shadow: 0 0 20px rgba(255, 255, 255, 0.8),
                        0 0 40px rgba(255, 215, 0, 0.6),
                        0 0 60px rgba(255, 215, 0, 0.4);
                    border-radius: 30px;
                    background: radial-gradient(circle at center,
                            rgba(255, 255, 255, 0.329) 0%,
                            rgba(76, 0, 255, 0.3) 70%,
                            transparent 100%);
                }

                @keyframes lightfade {
                    0% {
                        box-shadow: 0 0 20px rgba(255, 255, 255, 0.8),
                            0 0 40px rgba(255, 215, 0, 0.6),
                            0 0 60px rgba(255, 215, 0, 0.4);
                    }

                    50% {
                        box-shadow: 0 0 40px rgba(255, 255, 255, 1),
                            0 0 80px rgba(38, 0, 255, 0.8),
                            0 0 120px rgba(55, 0, 255, 0.6);
                    }

                    100% {
                        box-shadow: 0 0 20px rgba(255, 255, 255, 0),
                            0 0 40px rgba(68, 0, 255, 0.6),
                            0 0 60px rgba(55, 0, 255, 0.4);
                    }
                }
            }

            .backTarot {
                backface-visibility: hidden;
                position: absolute;
                transform: rotateY(180deg);
                // margin-top: 20px;
                width: 100%;
                text-align: center;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-around;

                .items {

                    width: 16%;
                    height: 250px;
                    margin: 0 3%;
                    margin-bottom: 20px;
                    padding: 10px 0px;
                    border: 3px #393636 solid;
                    border-radius: 10px;

                    .item {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: center;
                        height: 75%;

                        >img {
                            width: 100px;
                            height: 100px;
                        }

                        p {
                            color: #1e155d;
                            font-size: 14px;
                            margin: 10px 0;
                            font-weight: 700;
                        }

                        span {
                            color: #1e155d;
                            font-size: 14px;
                        }
                    }
                }

                >img {
                    margin-top: 35px;
                    width: 150px;
                }
            }

        }
    }

    /* 翻转状态 */
    .flipped {
        transform: rotateY(180deg);
    }

    .titflipped {
        transform: rotateY(-180deg);
    }

    .dialog {
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.575);
        bottom: 0;
        left: 0;
        position: fixed;
        z-index: 999;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;
    }

    .headerWX {
        width: 100%;
        position: absolute;
        top: 70px;
    }
}
</style>
